<template>
  <div>
    <el-form class="form-">
      <el-form-item label="序号">
        <el-input
          v-model="form.sort"
          class="form-input" />
      </el-form-item>
      <el-form-item label="标题">
        <el-input
          v-model="form.modal_name"
          class="form-input" />
      </el-form-item>
      <!-- <el-form-item label="祖流程">
        <el-input
          v-model="form.grandfather"
          class="form-input"
          disabled />
      </el-form-item>-->
      <el-form-item label="父流程">
        <el-input
          v-model="form.parent_modal_name"
          class="form-input"
          disabled />
      </el-form-item>
      <el-form-item label="模板选择">
        <el-select
          v-model="form.templateId"
          :remote-method="storeBefore"
          placeholder="空模板"
          style="width:100px"
          class="el-select-custom"
          filterable
          remote
          @change="changeTemplate"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.content"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="内容是否为空"
        style="display: flex;align-items: center;">
        <el-radio-group v-model="form.is_null">
          <el-radio :label="1">否</el-radio>
          <el-radio :label="0">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="custom-action">
        <el-button
          size="small"
          style="margin-left: 10px;"
          @click="fileReviewEdit('video')">插入视频</el-button>
        <el-button
          size="small"
          style="margin-left: 10px;"
          @click="addTag('en')">添加外教</el-button>
        <el-button
          size="small"
          style="margin-left: 10px;"
          @click="addTag('ch')">添加中教</el-button>
          <!-- <el-button
          style="margin-left: 10px;"
          @click="fileReviewEdit('file')"
        >{{ fileUrl !== '' ? '修改附件': '添加附件' }}</el-button>
        <el-button
          v-if="fileUrl !== ''"
          style="margin-left: 10px;"
        @click="removeFile">删除附件</el-button>-->
      </div>
      <el-form-item label>
        <AppTextArea
          ref="editor"
          :value="form.modal_content"
          :is-disable="false"
          :init-visible="true"
          :key="textareaKey"
          style="font-weight:bold;"
          @change="changeFn"
        />
      </el-form-item>
      <el-form-item style="display:flex;justify-content: center;">
        <el-button
          type="primary"
          @click="backMain">返回</el-button>
        <el-button @click="visibleContent = true">预览</el-button>
        <el-button
          type="primary"
          @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      :visible.sync="visibleContent"
      center
      style="z-index:10000">
      <div class="preview">
        <div v-html="form.modal_content" />
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          type="primary"
          @click="visibleContent = false">返回</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible="visible.review"
      :show-close="false"
      :title="visible.title"
      top="5vh">
      <FileReview
        v-if="visible.review"
        :id="visible.name"
        @success="reviewUpdate"
        @cancel="reviewCancel"
      />
    </el-dialog>
  </div>
</template>

<script>
import mapUtils, { $form, $http, axiosRequest, baseURISaas } from "@/utils";
import FileReview from "./FileReview.vue";

export default {
  name: "FlowContentEdit",
  components: {
    FileReview,
  },
  props: {
    form: {
      type: Object,
      required: {
        title: "",
      },
    },
    courseID: {
      type: Number,
      required: 0,
    },
  },
  data() {
    return {
      templateList: [],
      visible: {
        review: false,
        title: "",
        name: "",
      },
      visibleContent: false,
      options: [],
      textareaKey: Date.now(),
      fileUrl: "",
    };
  },

  mounted() {
    this.storeBefore();
  },
  methods: {
    changeFn(data) {
      this.form.modal_content = data;
    },
    addTag(tag) {
      this.$refs.editor.addTag(tag);
    },
    reviewEdit() {
      this.visible.review = true;
    },
    fileReviewEdit(name) {
      this.visible.review = true;
      this.visible.title = name === "file" ? "添加附件" : "插入视频";
      this.visible.name = name;
    },

    removeFile() {
      this.$confirm("确定删除该文件？", "删除确认", {
        showCancelButton: true,
        type: "warning",
        confirmButtonText: "删除",
        confirmButtonClass: "el-button--danger",
        // beforeClose,
      })
        .then(() => {
          this.$axios({
            method: "delete",
            url: `${baseURISaas}/Tutor/deleteTutorFileUrl`,
            params: {
              structure_id: this.courseID,
            },
          })
            .then((res) => {
              if (res.data.code === 1) {
                this.$alert("附件删除成功！", "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.fileUrl = "";
                  },
                });
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {});
        })
        .catch(() => {});
    },
    reviewUpdate(file, id) {
      switch (id) {
        case "file":
          this.fileUrl = file;
          this.$axios({
            method: "post",
            url: `${baseURISaas}/Tutor/saveTutorFileUrl`,
            data: {
              structure_id: this.courseID,
              file_url: file,
            },
          })
            .then((res) => {
              console.log(res.data.code);
              if (res.data.code === 1) {
                this.$alert("附件保存成功！", "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {});
          break;
        case "video":
          this.$refs.editor.addVideo(file);
      }
      this.visible.review = false;
    },

    onSubmit() {
      if (this.form.sort && this.form.modal_name) {
        this.form.modal_content = this.form.modal_content || "";
        axiosRequest
          .put(`/lesson_preparation/${this.form.id}`, this.form)
          .then((res) => {
            this.$message.success("编辑成功!");
            this.backMain();
          })
          .catch((error) => {});
      } else {
        this.$message.error("序号和标题不能为空!");
      }
    },

    backMain() {
      this.$emit("backMain");
    },

    storeBefore(query) {
      let url = "";
      if (query == "" || query == undefined) {
        url = "/content_template?page=1&per_page=50";
      } else {
        url = `/content_template?page=1&per_page=50&like[name]=${query}`;
      }
      axiosRequest.get(url).then((res) => {
        console.log(res);
        this.options = res.data;
      });
    },
    // searchTemplate(){

    // },
    changeTemplate(content) {
      console.log(content);
      this.form.modal_content = content;
      this.textareaKey = Date.now();
    },

    reviewCancel() {
      this.visible.review = false;
    },
  },
};
</script>

<style>
.form-input {
  width: 30%;
}
.custom-action {
  margin: 10px;
}
.el-select-custom .el-input {
  width: 190px;
}
</style>
